import axios from 'axios'

const { REACT_APP_API_URL, REACT_APP_GAZE_ADMIN_TOKEN, REACT_APP_GAZE_TOKEN } = process.env;

const addHost = config => {
  return new Promise((resolve, reject) => {
    const url = `${REACT_APP_API_URL}${config.url}`;
    return config.url.startsWith('/api/') ? resolve({ ...config, url }) : reject(config);
  });
};

const addLanguage = config => {
  return new Promise(resolve => {
    const ln = localStorage.getItem('i18nextLng');
    const url = `${config.url}${config.url.includes('?') ? '&' : '?'}ln=${ln ? ln.split('-')[0] : 'uk'}`;
    return resolve({ ...config, url, headers: { ...config.headers, ln: ln ? ln.split('-')[0] : 'uk' } });
  });
};

const addHeader = config => {
  return new Promise(resolve => {
    const isClientIdentity = config.url.includes('/api/client/identity');
    const isAdminIdentity = config.url.includes('/api/admin/identity');
    const identity = /.[?|&]identity=(client|admin)&?./.exec(config.url);

    let tokenName;
    if (isClientIdentity) {
      tokenName = REACT_APP_GAZE_TOKEN;
    } else if (isAdminIdentity) {
      tokenName = REACT_APP_GAZE_ADMIN_TOKEN;
    } else if (identity) {
      tokenName = identity[1] === 'client' ? REACT_APP_GAZE_TOKEN : REACT_APP_GAZE_ADMIN_TOKEN;
    } else {
      tokenName = REACT_APP_GAZE_ADMIN_TOKEN || REACT_APP_GAZE_TOKEN;
    }

    const token = localStorage.getItem(tokenName);

    return token
      ? resolve({ ...config, headers: { ...config.headers, 'X-Auth-Token': token } })
      : resolve(config);
  });
};

axios.interceptors.request.use(async config => {
  return await addHost(config)
    .then(addLanguage)
    .then(addHeader)
    .catch(config => config);
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});